import { cn } from "@/lib/utils";

// PLACEHOLDER LOGO — a 2:1 (wider-than-tall) provisional lockup standing in for the
// real brand mark (#ui-polish, Leon). It's an inline SVG on purpose: it inherits the
// loaded display font and `currentColor`, so it themes with the surface (light chrome
// vs the dark Stage) and stays crisp at any size. Swap the innards for the final art
// when it lands — keep the 2:1 viewBox so the reserved slot doesn't shift.
//
// The mark is a soft "pillow": a rounded square with a stitched seam outline and two
// corner tufts — the sewn-keepsake motif that also shows up in the chrome's stitch
// divider. Coral mark, wordmark in currentColor.
export function Logo({ className, title = "pufimi" }: { className?: string; title?: string }) {
  return (
    <svg
      viewBox="0 0 120 60"
      role="img"
      aria-label={title}
      className={cn("h-7 w-auto", className)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Pillow mark */}
      <g>
        <rect x="6" y="14" width="34" height="34" rx="11" fill="hsl(12 84% 64%)" />
        {/* Stitched seam, inset — the sewn-pillow motif */}
        <rect
          x="12"
          y="20"
          width="22"
          height="22"
          rx="7"
          fill="none"
          stroke="#ffffff"
          strokeOpacity="0.85"
          strokeWidth="1.6"
          strokeDasharray="2.4 2.6"
        />
        {/* Corner tufts */}
        <circle cx="12.5" cy="20.5" r="1.5" fill="#ffffff" fillOpacity="0.9" />
        <circle cx="33.5" cy="41.5" r="1.5" fill="#ffffff" fillOpacity="0.9" />
      </g>
      {/* Wordmark — textLength pins it inside the 2:1 viewBox so the trailing glyph
          never clips regardless of the rendered font's metrics. */}
      <text
        x="48"
        y="38.5"
        fill="currentColor"
        fontFamily="var(--font-display)"
        fontSize="24"
        fontWeight="600"
        letterSpacing="-0.5"
        textLength="66"
        lengthAdjust="spacingAndGlyphs"
      >
        pufimi
      </text>
    </svg>
  );
}
